import {
  set
} from '../redux/activities'
import _requestRemoveBookmark from 'store/sagas/requestRemoveBookmark'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  boardId: number
  id: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { boardId, id } = payload

  const activity = getState()['view-board'].activities[boardId].activitiesById[id]

  let optimisticAction
  if (activity) {
    optimisticAction = optimisticDispatch(dispatch, set({
      boardId,
      activity: {
        id,
        isBookmarked: false
      }
    }))
  }

  try {
    await dispatch(_requestRemoveBookmark({
      id,
    }))

    optimisticAction?.commit()
  } catch (error) {
    optimisticAction?.revert()

    throw error
  }
}

